import { Drawer, IconButton, Stack, useMediaQuery, useTheme, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import "./styles.scss";
import { SidebarMenu } from "./SidebarMenu";
import { getAdminSidebarConfig } from "./AdminSidebarConfig";
import { SealIcon } from "../../../seal-icon";
import { useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";
import { Pages } from "../../../../utils";

interface Props {
  showScrollbar: boolean;
  handleSidebarScroll: () => void;
}

export const AdminSidebar = ({ showScrollbar, handleSidebarScroll }: Props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = useState(!isMobile);
  const toggleDrawer = (open: boolean) => () => setDrawerOpen(open);
  const scrollableRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = scrollableRef.current;
    if (!el) return;
    el.addEventListener("wheel", handleSidebarScroll, { passive: true });
    return () => {
      el.removeEventListener("wheel", handleSidebarScroll);
    };
  }, [handleSidebarScroll]);

  const content = (
    <Stack
      spacing={2}
      className={`sidebar-content ${!isMobile && showScrollbar ? "scroll-visible" : ""}`}
      ref={scrollableRef}
      onMouseEnter={handleSidebarScroll}
      onWheel={handleSidebarScroll}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" px={2}>
        {isMobile && (
          <IconButton onClick={toggleDrawer(false)} sx={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        )}
        <IconButton
          component="a"
          href="https://homedesignguild.com/"
          aria-label="Go to Home Design Guild main website"
          onClick={(event) => event.stopPropagation()}
          sx={{ p: 0, borderRadius: 0 }}
        >
          <SealIcon color="#fff" />
        </IconButton>
      </Stack>
      <SidebarMenu config={getAdminSidebarConfig()} />
    </Stack>
  );

  return (
    <>
      {isMobile && (
        <>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
            sx={{ color: "#fff", top: 16, left: 16, zIndex: 1300 }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ position: "absolute", alignSelf: "center", left: 60 }}>
            <Stack direction="row" spacing={2} alignItems="center">
              <IconButton onClick={() => navigate(Pages.ADMIN_MATCHES)} sx={{ color: "#fff" }}>
                <FavoriteBorderIcon sx={{ fontSize: 18 }} />
              </IconButton>
              <Typography variant="body1" sx={{ color: "#fff" }}>
                Matches
              </Typography>
            </Stack>
          </Box>
        </>
      )}

      <Drawer
        anchor="left"
        open={drawerOpen || !isMobile}
        onClose={toggleDrawer(false)}
        variant={isMobile ? "temporary" : "permanent"}
        PaperProps={{
          sx: {
            width: "220px !important", // Reduced from 260px for more modern feel - UPDATED
            backgroundColor: "#374a67",
            color: "#fff",
            pt: 1.5, // Reduced padding
            borderRight: 0,
            borderRadius: isMobile ? "0 20px 20px 0" : "0",
            boxShadow: "none", // Cleaner look without shadow
            "& .MuiPaper-root": {
              width: "220px !important",
            },
          },
        }}
      >
        {content}
      </Drawer>

    </>
  );
};
